const state = {
  ...window.__initialAppState.modules.productsListPage
};

export default state;
